import { useSelector } from 'react-redux'
import { selectMapViewDialogOpen } from '@user/store/map/slice'

export function useData() {
  const open = useSelector(selectMapViewDialogOpen)

  return { open }
}

export type UseData = ReturnType<typeof useData>
